import { render, staticRenderFns } from "./InstructionsMapSkeleton.vue?vue&type=template&id=6c39774c&scoped=true"
import script from "./InstructionsMapSkeleton.vue?vue&type=script&lang=js"
export * from "./InstructionsMapSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InstructionsMapSkeleton.vue?vue&type=style&index=0&id=6c39774c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c39774c",
  null
  
)

export default component.exports